module.exports = __webpack_public_path__ + "static/media/scr_ios_LightKeyboard.eba49602.png";